import "../../constants.js";
import { stylable as t } from "../decorators/stylable.js";
const s = t({
  content: "listItem+",
  attrs: { type: { default: "orderedList" } },
  group: "list",
  parseDOM: [{ tag: "ol" }],
  toDOM() {
    return ["ol", 0];
  }
}), o = t({
  content: "listItem+",
  attrs: { type: { default: "unorderedList" } },
  group: "list",
  parseDOM: [{ tag: "ul" }],
  toDOM() {
    return ["ul", 0];
  }
}), n = {
  content: "paragraph",
  group: "listItem",
  parseDOM: [{ tag: "li" }],
  toDOM() {
    return ["li", 0];
  },
  defining: !0
}, i = {
  content: "nestedListItem+",
  attrs: { type: { default: "orderedNestedList" } },
  group: "list",
  parseDOM: [{ tag: "ol" }],
  toDOM() {
    return ["ol", 0];
  }
}, d = {
  content: "nestedListItem+",
  attrs: { type: { default: "unorderedNestedList" } },
  group: "list",
  parseDOM: [{ tag: "ul" }],
  toDOM() {
    return ["ul", 0];
  }
}, l = {
  content: "block (block | list)*",
  defining: !0,
  parseDOM: [{ tag: "li" }],
  toDOM() {
    return ["li", 0];
  }
};
export {
  n as listItemSpec,
  l as nestedListItemSpec,
  s as orderedListSpec,
  i as orderedNestedListSpec,
  o as unorderedListSpec,
  d as unorderedNestedListSpec
};
